import { Location, NavigateFunction } from "react-router-dom";

import { ROUTES } from "@/constants/routes";

type NavigateToInvoicePageParams = {
  navigate: NavigateFunction;
  location: Location;
  routeSegment: string;
  entityId: string;
  year: string;
  month: string;
  locationStateKey: string;
  currentPageLabel?: string;
  entityName?: string;
};

export function navigateToInvoicePage({
  navigate,
  location,
  routeSegment,
  entityId,
  year,
  month,
  locationStateKey,
  currentPageLabel,
  entityName,
}: NavigateToInvoicePageParams) {
  const getSelectedTabId = () => {
    const currentPath = location.pathname;
    if (currentPath.includes(`/${ROUTES.toDo}`)) {
      return "toDo";
    }
    if (currentPath.includes(`/${ROUTES.invoiced}`)) {
      return "invoiced";
    }
    return "toDo";
  };

  // Use provided year/month parameters - they are the source of truth
  // Only extract from URL as fallback if parameters are not provided
  let finalYear = year;
  let finalMonth = month;
  
  if (!finalYear || !finalMonth) {
    const pathParts = location.pathname.split("/");
    const invoicesIndex = pathParts.indexOf(ROUTES.invoices);
    if (invoicesIndex !== -1 && pathParts.length > invoicesIndex + 5) {
      const currentYearFromUrl = pathParts[invoicesIndex + 5];
      const currentMonthFromUrl = pathParts[invoicesIndex + 6];
      if (currentYearFromUrl && currentMonthFromUrl) {
        finalYear = currentYearFromUrl;
        finalMonth = currentMonthFromUrl;
      }
    }
  }

  const currentTab = getSelectedTabId() || "toDo";
  const tabRoute = currentTab === "toDo" ? ROUTES.toDo : ROUTES.invoiced;
  const searchParams = new URLSearchParams(location.search);
  searchParams.delete("page");
  const cleanSearch = searchParams.toString();
  const searchString = cleanSearch ? `?${cleanSearch}` : "";

  navigate(
    `/${ROUTES.invoices}/${routeSegment}/${entityId}/${tabRoute}/${finalYear}/${finalMonth}${searchString}`,
    {
      state: {
        [locationStateKey]: currentPageLabel ?? entityName,
      },
    }
  );
}
